import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import _ from 'lodash';

const LOCALE_PREFIX = 'US/pages/LandingPage/HowItWorks';

export class HowItWorks extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };
    render() {
        return (
            <div className="how-it-works-container">
                <div className="how-it-works-header">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.header`} />
                </div>
                <div className="how-it-works-subheader">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.subheader`} />
                </div>
                <ul className="how-it-works-list">
                    {_.times(6, i => (
                        <li key={`bullet${i}`}>
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.bullet${i}`} />
                        </li>
                    ))}
                </ul>
                <div className="how-it-works-subheader">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.additionalInfoHeader`} />
                </div>
                <ul className="how-it-works-list">
                    {_.times(3, i => (
                        <li key={`additionalBullet${i}`}>
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.additionalBullet${i}`} />
                        </li>
                    ))}
                </ul>
                <div className="how-it-works-disclaimer">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.howItWorksFooter`} />
                </div>
            </div>
        );
    }
}

export default connect()(injectIntl(HowItWorks));
